<template>
  <div class="border-2 border-gray-800">
    
    <LiabilityHeader 
      :index="index" 
      :updateValue="updateValue"
      :liabilityId="liability.id"
      :liabilityType="parseInt(liability.type)"
      :deleteLiability="deleteLiability"></LiabilityHeader>

    <div class="flex flex-wrap -mx-2 p-4">
      <div class="w-full lg:w-1/4 px-2">
        <LenderSelector
          label="Lender"
          objectType="liability"
          objectSubType="carLease"
          propertyKey="lender"
          :index="index"
          :objectId="objectId"
          :value="liability.lender"
          :updateValue="updateValue" />

        <div class="mt-6" v-if="liability.lender != null && isOtherLander(liability.lender)">
          <InputText 
            label="Name of lender"
            propertyKey="lender"
            objectType="liability"
            :index="index"
            :objectId="liability.id"
            :value="liability.lender"
            :updateValue="updateValue" />
        </div>

        <div class="mt-6">
          <InputText 
            label="Account number"
            propertyKey="account_number"
            :index="index"
            :objectId="objectId"
            :value="liability.account_number"
            :updateValue="updateValue" />
        </div>
      </div>

      <div class="w-full lg:w-1/2 px-2 lg:px-0">
        <div class="flex flex-wrap">
          <div class="w-full lg:w-1/3 px-0 lg:px-2 mt-6 lg:mt-0">
            <InputDollarValue 
              label="Monthly payment"
              propertyKey="monthly_payment"
              objectType="liability"
              :objectId="liability.id"
              :index="index"
              :value="liability.monthly_payment"
              :updateValue="updateValue"/>
          </div>

          <div class="w-full lg:w-1/3 px-0 lg:px-2 mt-6 lg:mt-0">
            <InputDollarValue 
              label="Limit"
              propertyKey="limit"
              objectType="liability"
              tooltip="What is the maximum limit that you have?"
              :objectId="liability.id"
              :index="index"
              :value="liability.limit"
              :updateValue="updateValue"/>
          </div>

          <div class="w-full lg:w-1/3 px-0 lg:px-2 mt-6 lg:mt-0">
            <InputDollarValue 
              label="Balance"
              propertyKey="balance"
              objectType="liability"
              tooltip="What amount do you currently owe?"
              :objectId="liability.id"
              :index="index"
              :value="liability.balance"
              :updateValue="updateValue"/>
          </div>
        </div>
      </div>

      <div class="w-full lg:w-1/4 px-2 mt-6 lg:mt-0">
        <Ownership :liability="liability" />
      </div>
    </div>
  </div>
</template>

<script>
  import LiabilityHeader  from '../LiabilityHeader'
  import LenderSelector   from '@/shared/components/form/LenderSelector'
  import InputText        from '@/shared/components/form/InputText'
  import InputDollarValue from '@/shared/components/form/InputDollarValue'
  import Ownership        from '@/shared/components/Ownership'

  export default {

    components: {
      LiabilityHeader,
      LenderSelector,
      InputText,
      InputDollarValue,
      Ownership
    },

    props : {
      liability : {
        type : Object,
        required : true
      },

      index : {
        type : Number,
        required : false
      },

      objectId : {
        type : Number,
        required : false
      },

      updateValue : {
        type     : Function,
        required : false
      },

      deleteLiability : {
        type    : Function,
        required: false
      },
    },

    methods : {

      // localUpdateValue steps in between the child component and the
      // parent component in order to inject an extra argument to the 
      // update value function since for liabilitys, we also need which
      // liability we are currently updating
      localUpdateValue(key, value) {
        this.updateValue({
          objectId: this.liability.id,
          index   :  this.index, 
          key     : key, 
          value   : value
        })
      }
    }

  }
</script>